import { render, staticRenderFns } from "./SetUrgent.vue?vue&type=template&id=35a9d6b4&"
import script from "./SetUrgent.vue?vue&type=script&lang=js&"
export * from "./SetUrgent.vue?vue&type=script&lang=js&"
import style0 from "./SetUrgent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports